module.exports = __webpack_public_path__ + "static/img/info1.b12a13b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/pic/info1.jpg
// module id = PQP3
// module chunks = 11